package org.lennycodes.hldi.backend

object FirebaseService {

    private val config = js("""
    ({
          apiKey: "AIzaSyD2KcksueDpbGwffaAAQzkAts6kVHH_mbA",
  authDomain: "hldi-b3040.firebaseapp.com",
  projectId: "hldi-b3040",
  storageBucket: "hldi-b3040.firebasestorage.app",
  messagingSenderId: "966159783090",
  appId: "1:966159783090:web:147e8c90c91021f9d865ab",
  measurementId: "G-D43BDGNTJ1"
    })
    """)

    val app = initializeApp(config)

    val auth = getAuth(app)

    val db = getFirestore(app)

    val storage = getStorage(app)
}
external fun getCurrentUser(auth: dynamic): dynamic

fun isUserLoggedIn(): Boolean {
    return getCurrentUser(FirebaseService.auth) != null
}